export const AlgoliaConfig = {
         apiKey: 'efb1bcb739d8c03955e74b4abef97ba5',
       }
